import { defaultFill } from '../../../utils/constants';
var muiInfoFill16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M9,7 L7,7 L7,12 L9,12 L9,7 Z M8,4 C7.44771525,4 7,4.44771525 7,5 C7,5.55228475 7.44771525,6 8,6 C8.55228475,6 9,5.55228475 9,5 C9,4.44771525 8.55228475,4 8,4 Z',
            fill: defaultFill,
        },
    ],
    title: 'Info',
    width: 16,
    height: 16,
};
var muiInfoFill24 = {
    paths: [
        {
            path: 'M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M12.5,9.5 L9.5,9.5 L9.5,17 L12.5,17 L12.5,9.5 Z M11,5 C10.1715729,5 9.5,5.67157288 9.5,6.5 C9.5,7.32842712 10.1715729,8 11,8 C11.8284271,8 12.5,7.32842712 12.5,6.5 C12.5,5.67157288 11.8284271,5 11,5 Z',
            fill: defaultFill,
        },
    ],
    title: 'Info',
    width: 22,
    height: 22,
};
var muiInfoFill = {
    base: muiInfoFill16,
    smIcon: muiInfoFill16,
    lgIcon: muiInfoFill24,
};
export { muiInfoFill };
//# sourceMappingURL=infoFill.js.map